<account-page title="Addresses">
	<cdk-table-component
		[displayColumns]="displayColumns"
		[entities]="tableEntities"
		[dataSource]="dataSource"
	></cdk-table-component>
</account-page>
